import { Reveal, Overline } from "@/components/Reveal";
import { VideoCard } from "@/components/Videos";

const RESULTS = [
  { id: "7w70ofB6a_0", title: "he landed multiple dates off cold approach in a few weeks… here's how" },
  { id: "Qqask763U4E", title: "anxiety almost ruined his dating life until he tried this..." },
  { id: "Aje1yRLF6fE", title: "from GHOSTED to DATING ABUNDANCE.. here's how he did it" },
];

export default function Testimonials() {
  return (
    <section id="results" className="border-t border-white/10 bg-[#0d0d0d]" data-testid="testimonials-section">
      <div className="mx-auto max-w-6xl px-6 py-28 text-center lg:px-10 lg:py-40">
        <Reveal>
          <Overline>Client Results</Overline>
          <h2 className="mx-auto mt-6 max-w-2xl font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl">
            Real men. Real transformations. <span className="italic text-neutral-400">Real dates.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-8 text-left md:grid-cols-3">
          {RESULTS.map((v, i) => (
            <VideoCard key={v.id} video={v} index={i} testIdPrefix="testimonial" />
          ))}
        </div>

        <Reveal delay={0.2} className="mt-10">
          <p className="text-xs uppercase tracking-[0.25em] text-neutral-600" data-testid="testimonials-disclaimer">
            Full client interviews, in their own words.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
